import { render, staticRenderFns } from "./cgm-week-danger.vue?vue&type=template&id=d4ea87d0&scoped=true&"
import script from "./cgm-week-danger.vue?vue&type=script&lang=js&"
export * from "./cgm-week-danger.vue?vue&type=script&lang=js&"
import style0 from "./cgm-week-danger.vue?vue&type=style&index=0&id=d4ea87d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ea87d0",
  null
  
)

export default component.exports